import {RoleEnum} from "./RoleEnum";

export function isAdministrator(roles: string[]) {
    return roles.includes(RoleEnum.STAFF_GM_IS);
}